module.exports = __webpack_public_path__ + "img/Warehousing_1200x800.78b7bd56.png";